import React, { useEffect, useRef } from "react";
import { Images, Services } from "../../../Controller";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setselectedTab } from "../../../Store/B2bslice";
function BBPSServiceMain() {
  const profiledetail = useSelector((state) => state.B2B.profileDetail);
  const memberServices = useSelector((state) => state.B2B.memberServices);
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const checkEKOonboardStatus = () => {
    if (profiledetail.eko_onboard_status == "0") {
      return true;
    }
  };
  useEffect(() => {
    dispatch(setselectedTab("201"));
  }, []);
  return (
    <div className="m-4">
      {" "}
      <div className="grid grid-cols-1  md:grid-cols-3  place-items-start gap-3">
        {(memberServices.includes("103") || memberServices.includes("2")) && (
          <div className="shadow-[0px_2px_2px_#ccdcff] p-2 border-rgbaprimary9 border-b-2 bg-white h-18 text-center w-full rounded-xl cursor-pointer">
            <p className="text-rgbaprimary7 text-base leading-5 font-bold mt-4">
              BBPS
            </p>
            <div className="grid grid-cols-1 gap-4 mt-4">
              <div
                className=" bg-primary rounded-xl cursor-pointer border-rgbaprimary9 border-t-2  justify-items-center"
                onClick={() =>
                  navigate(
                    memberServices.includes("103")
                      ? "/eko/bbps"
                      : memberServices.includes("2")
                        ? "/bbps"
                        : "/not-available",
                  )
                }
              >
                <p className="text-white text-base font-bold p-2 ">BBPS</p>
              </div>
            </div>
          </div>
        )}
        {memberServices.includes("110") && (
          <div className="shadow-[0px_2px_2px_#ccdcff] p-2 border-rgbaprimary9 border-b-2 bg-white h-18 text-center w-full rounded-xl cursor-pointer">
            <p className="text-rgbaprimary7 text-base leading-5 font-bold mt-4">
              BBPS 2
            </p>
            <div className="grid grid-cols-1 gap-4 mt-4">
              <div
                className=" bg-primary rounded-xl cursor-pointer border-rgbaprimary9 border-t-2  justify-items-center"
                onClick={() =>
                  navigate(
                    memberServices.includes("110")
                      ? "/eko/bbps-offline"
                      : "/not-available",
                  )
                }
              >
                <p className="text-white text-base font-bold p-2 ">BBPS 2</p>
              </div>
            </div>
          </div>
        )}
        {(memberServices.includes("116") ||
          memberServices.includes("117") ||
          memberServices.includes("118")) && (
          <div className="shadow-[0px_2px_2px_#ccdcff] p-2 border-rgbaprimary9 border-b-2 bg-white text-center  w-full rounded-xl cursor-pointer">
            <p className="text-rgbaprimary7 text-base leading-5 font-bold mt-4">
              BBPS Offline
            </p>
            <div className="grid grid-cols-1  gap-4 mt-4">
              {memberServices.includes("116") && (
                <div
                  className=" bg-primary rounded-xl cursor-pointer border-rgbaprimary9 border-t-2  justify-items-center"
                  onClick={() => navigate("/BbpsOffline1/part_payment")}
                >
                  <p className="text-white text-base font-bold p-2 ">
                    Part Payment
                  </p>
                </div>
              )}

              {memberServices.includes("117") && (
                <div
                  className=" bg-primary rounded-xl cursor-pointer border-rgbaprimary9 border-t-2  justify-items-center"
                  onClick={() => navigate("/BbpsOffline1/lease_part_payment")}
                >
                  <p className="text-white text-base font-bold p-2 text-center">
                    Least Part Payment
                  </p>
                </div>
              )}
              {memberServices.includes("118") && (
                <div
                  className=" bg-primary rounded-xl cursor-pointer border-rgbaprimary9 border-t-2  justify-items-center"
                  onClick={() => navigate("/BbpsOffline1/bawana_infra")}
                >
                  <p className="text-white text-base font-bold p-2 text-center">
                    Bawana Infra
                  </p>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
export default BBPSServiceMain;
